/* 
PUBLIC PAGE 
*/
import React from "react";
import ForTrucks from "../Components/ForTrucks/ForTrucks";
import Layout from "../Components/Layout/Layout";

export default function ForTrucksPage() {
  return (
    <Layout>
        <ForTrucks />
    </Layout>
  );
}
